import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { UserRoleViewModel } from '../../../business-entities/user-role-view-model';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { RolesRightsService } from '../../../business-services/roles-rights.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { CustomerService } from './../../../business-services/customer.service';
import { ReceptionService } from './../../../business-services/reception.service';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import * as Enums from "projects/Autofacets-Core/src/app/utils/enums";
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { SettingService } from '../../../business-services/setting.service';


@Component({
  selector: 'app-add-reception',
  templateUrl: './add-reception.component.html',
  styleUrls: ['./add-reception.component.css']
})
export class AddReceptionComponent implements OnInit {

  addUserForm: FormGroup;
  dealerList: Array<any>;
  dealerListSingleSelection: Array<any>;
  userMobileCode: string;
  roleList: UserRoleViewModel[];
  employeeList:any[]=[]
  selectedRoleId:number;
  dropdownSettings = {};
  searchString = '';
  addUser:boolean=false;
  isAddedAsUser:boolean=false;
  receptionRole:boolean=false;
  employeeId:number;
  countryList: any;
  countryCode:any;
  isSearched:boolean = false;
  userRoleRightsDetails: UserRoleMenu;
  closeResult: string;
  EmployeeListRequestModel={
    startRecordNumber: 0,
    PageSize: 25,
    searchString: '',
    isFromMechanicScreen: false,
  }
  throttle = 100;
  scrollDistance = 1;
  totalCount: number = 0;
  selectedDealer:any[]=[];
  areCodesHidden = false;
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISO= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    public dealerBusinessService: DealerBusinessService,
    private readonly receptionBusinessService: ReceptionService,
    private readonly CustomerService: CustomerService,
    private readonly toastr: ToastrService,
    private readonly translate: TranslateService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly userService: UserDataService,
    private readonly rolesRightsService: RolesRightsService,
    private readonly activeModal : NgbActiveModal,
    private readonly modalService: NgbModal,
    private readonly settingService: SettingService
  ) { }

  async ngOnInit(): Promise<void> {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this.areCodesHidden = localStorage.getItem('Theme') === 'mg';
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search here',
      maxHeight: 500,
      enableCheckAll:false
    };
    this.addUserForm = this.formBuilder.group({
      roleId:['',[Validators.required]],
      dealerId: ['', [Validators.required]],
      name: [{value: '', disabled: localStorage.getItem("Theme") !== 'mg'}, [Validators.required]],
      landline: ['', [Validators.pattern(/^\d{8,10}$/)]],
      mobile: [{value: ''}, [Validators.required]],
      adEmail: [{value: ''}, [Validators.required, Validators.pattern(Enums.RegexKeyCollection.Email)]],
      isActive: [true],
      adUserId: [null, [Validators.required]],
    });
    await this.countryDropdownDetails();
    await this.getUserDealers();
    await this.getRoleList();
    await this.SearchEmployee();
  }

  get cpf() {
    return this.addUserForm.controls;
  }
  onRoleChange(role){
    let r = role.split(':');
    let ro = +r[1];
    if(ro === fromEnums.UserRoles.Reception)
    {
      this.addUserForm.controls['dealerId'].setValue('');
      this.receptionRole = true;
    }
    else{
      this.addUserForm.controls['dealerId'].setValue('');
      this.receptionRole = false;
    }
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel,false);
      this.dealerListSingleSelection = this.mapdealer(response.userDealersModel,true);
    })
  }

  mapdealer(array: UserDealersModel[],singleSelection:boolean){
    let supperArray = [];
    if (array && array.length > 0) {
      if(!singleSelection)
      {
        let single = Object();
        single.value = '-1'
        single.text = 'All'

        supperArray.push(single);
      }
      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName
        single.locationCode = element.locationCode
        supperArray.push(single);
      })
    }
    return supperArray;
  }


  onItemSelect(event)
    {
      if(event.value==='-1')
      {
        this.addUserForm.patchValue({
          dealerId:null
        })
        let selectedItems=[]
        this.dealerList.forEach(x=>{
          selectedItems.push(x);
         })
        this.addUserForm.patchValue({
          dealerId:selectedItems
        })
      }
    }

    onItemDeSelect(event)
    {
      if(event.value==='-1')
      {
        this.addUserForm.patchValue({
          dealerId:null
        })
        let selectedItems=[]
        this.addUserForm.patchValue({
          dealerId:selectedItems
        })
      }

      if(this.addUserForm.get('dealerId').value.length>0)
      {
        let index=this.addUserForm.get('dealerId').value.findIndex(x=>x.value==='-1')
        if(index!==null || index!==undefined || index!==-1)
        {
          this.addUserForm.get('dealerId').value.splice(index,1);
        }
      }
    }

  ClearEmployee(){
    this.employeeList=[];
    this.searchString = ''
    this.SearchEmployee();
  }
  async getRoleList()
  {
    this.spinner.show();
    await this.rolesRightsService.getRoleList().then(response => {
      if (response) {
       this.roleList=response.responseObject.result;
       let currentUserPriority=this.roleList.filter(x=>x.id===this.userService.currentUserValue.roleType)[0]?.priority;
       if(currentUserPriority)
       {
        this.roleList=this.roleList.filter(x=>x.priority>currentUserPriority);
       }
      }
      this.spinner.hide();
    });
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.employeeList.length){
      this.EmployeeListRequestModel.startRecordNumber = this.employeeList.length
      this.SearchEmployee();
    }
  }


  async SearchEmployee(isFromSearch=false){
    this.addUser = false;
    this.isAddedAsUser=false;

    this.searchString = this.searchString.trim();
      this.isSearched = true;
      if(isFromSearch)
      {
        this.employeeList = [];
        this.EmployeeListRequestModel.startRecordNumber=0;
      }

      this.spinner.show();
      this.EmployeeListRequestModel.searchString=this.searchString;
      await this.rolesRightsService.getEmployeeList(this.EmployeeListRequestModel).then((res) =>{
        this.totalCount = 0;
        if(res?.responseObject && res?.responseObject.length > 0){
          this.employeeList.push(...this.employeeDataMapper(res?.responseObject))
          this.totalCount = this.employeeList? this.employeeList[0].totalCount:0;
        }
        this.spinner.hide();
      })
    //}
  }

  private employeeDataMapper(employee) {
    return employee.map((emp, i) => {
      return {
         row: i + 1,
         id:emp.id,
         firstName:emp.firstName,
         lastName:emp.lastName,
         email:emp.email,
         phoneNo:emp.phoneNo,
         phoneCode:emp.phoneCode,
         isAddedAsUser:emp.isAddedAsUser,
         adEmail:emp.adEmail,
         groupRoleName:emp.groupRoleName,
         functionCode:emp.functionCode,
         functionCodeDescription:emp.functionCodeDescription ,
         locationCode:emp.locationCode ,
         locationName:emp.locationName ,
         employeeNo:emp.employeeNo ,
         totalCount:emp.totalCount ,
         adGuid :emp.adGuid
      }
    });
  }
  async countryDropdownDetails(): Promise<void> {
    this.spinner.show();
    await this.CustomerService.getCountryCodeAndMobileCodeDetails()
      .then((response) => {
        this.spinner.hide();
          this.countryList = response?.responseObject?.result.filter(x => x.isDisplay);
      },  _error => {
        this.spinner.hide()
      });
  }
  OpenAddUserForm(content:any,user:any){
    this.addUserForm.controls['roleId'].setValue('');
    this.addUserForm.controls['dealerId'].setValue('');
    this.addUserForm.controls['name'].setValue('');
    this.addUserForm.controls['landline'].setValue('');
    this.addUserForm.controls['mobile'].setValue('');
    this.addUserForm.controls['adEmail'].setValue('');
    this.addUserForm.controls['isActive'].setValue(true);
    this.addUserForm.controls['adUserId'].setValue(user.adGuid);


    this.employeeId = user.id;
    this.addUser = true;
    this.isAddedAsUser=user.isAddedAsUser;
    let object = {
      text:this.dealerList.filter(x=>x.locationCode === user.locationCode)[0]?.text,
      value:this.dealerList.filter(x=>x.locationCode === user.locationCode)[0]?.value
    }

    this.addUserForm.patchValue({
      name: (user.firstName + ' '+ user.lastName),
      mobile: user.phoneNo,
      adEmail:user.email
    })
    if(object.text)
    {
      this.addUserForm.patchValue({
        dealerId:[object]
      })
    }

    let obj = this.countryList.filter(f => f.mobileCode.replace("+","") == user.phoneCode.replace("+",""));
    if(obj.length > 0) {
      this.countryCode = obj[0].code
      this.userMobileCode = this.countryCode
      if(obj[0].code){
        this.selectedCountryISO= obj[0].code;
      }
    }
    this.modalService.open(content, {size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }



  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  onSubmit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.Reception);
    if(!this.userRoleRightsDetails.canAdd){
      let errorMsg=this.translate.instant('lblNoRightsToAddUser');
      this.toastr.error(errorMsg);
      return;
    }
    if(this.isAddedAsUser)
    {
      let errorMsg=this.translate.instant('lblUserAlreadyExistsAndCanReAssociate');
      this.toastr.error(errorMsg);
      return;
    }
    if (this.addUserForm.invalid) {
      return;
    }
    let dealerId;
    if(this.receptionRole){
     dealerId = this.addUserForm.get('dealerId').value
    }
    else{
      if(this.addUserForm.get('dealerId').value.length === this.dealerList.length){
        dealerId = '-1'
      }
      else{
        dealerId = this.addUserForm.get('dealerId').value.map(x=>x.value).join(',')
      }
    }
    const viewModel = {...this.addUserForm.value,dealerId: dealerId, name:this.cpf.name.value, mobile: this.cpf.mobile.value?.number ? this.cpf.mobile.value.number.toString().replace(/\s+/g, '') : this.cpf.mobile.value,email: this.cpf.adEmail.value.toString().toLowerCase(),dealerName:null, mobileCode: this.userMobileCode ,employeeId: this.employeeId,existingIsActiveStatus:false };
    this.spinner.show();
      let successmsg = this.translate.instant('lblUserAdded');
      let errormsg = this.translate.instant('lblAddUserFailed');
      let emailError=this.translate.instant('lblAdEmailAlreadyExists');
      let adUserError=this.translate.instant('lblAdUserIdAlreadyExists');
      let userLimitError = this.translate.instant('lblUserCreationLimitExceed');
        this.receptionBusinessService.addUpdateUser(viewModel).then((response) => {
            this.spinner.hide();
            let result = response.responseObject;
            if (result) {
                if (result.errorCount && result.errorCount > 0) {
                    let errorResponse = result.result;
                    if (errorResponse.errorCode === fromEnums.ErrorCodes.EmailAlreadyExistsErrorCode) {
                        this.toastr.error(emailError);
                    }
                    if (errorResponse.errorCode === fromEnums.ErrorCodes.AdUserIdAlreadyExistsErrorCode) {
                      this.toastr.error(adUserError);
                  }
                  if(errorResponse.errorCode === fromEnums.ErrorCodes.UserCreationLimitExceed){
                    this.toastr.error(userLimitError);
                  }
                } else {
                   document.getElementById("modelButton").click();
                    this.toastr.success(successmsg);

                    this.activeModal.close({ success: true });
                }
            } else {
                this.toastr.error(errormsg);
            }
        });
  }

  telInputObject() {
    if(this.countryCode !== undefined) {
      this.selectedCountryISO= this.countryCode;
      }
      else{
        this.selectedCountryISO= this.cultureLocaleService.getLocale();
      }
  }

  onCountryChange(obj) {
    if (this.isInitialLoad) {
    this.telInputObject();
    this.userMobileCode = this.userMobileCode || obj.dialCode;
    this.isInitialLoad = false;
    } else {
      this.userMobileCode = obj.dialCode;
    }
  }
  OnClose(){
    this.activeModal.dismiss('Cross click')
  }
  onMobileNoChange(){
    if(this.addUserForm.get('mobile').value){
      let len= this.addUserForm.get('mobile').value.number.toString().replace(/\s+/g, '').length;
      if(len<8 || len>11){
        this.addUserForm.get('mobile').setValidators([Validators.required, Validators.pattern(/^\d{8,11}$/)]);
        this.addUserForm.get('mobile').updateValueAndValidity();
      } else {
        this.addUserForm.get('mobile').setValidators([Validators.required]);
        this.addUserForm.get('mobile').updateValueAndValidity();
      }
    }
  }

}
